module.exports = __webpack_public_path__ + "img/american.92d82e86.svg";